import type Pessoa from "model/administracao/cadastro/Pessoa";
import type Produto from "model/administracao/cadastro/produto/Produto";
import type TransacaoNotaFiscal from "model/fiscal/TransacaoNotaFiscal";

export default class ProdutoCliente {
    idUnidadeOrganizacional?: number | null;
    idSituacaoTributaria?: number | null;
    idIcmsEspecial?: number | null;
    idReducaoImposto?: number | null;
    idSubstituicaoTributaria?: number | null;
    idDispositivoFiscal?: number | null;
    idClassificacaoTributariaIbsCbs?: number | null;
    aliquotaPis?: number | null;
    aliquotaCofins?: number | null;
    aliquotaIpi?: number | null;

    id: number | null = null;
    cliente: Pessoa | null = null;
    transacaoNotaFiscal: TransacaoNotaFiscal | null = null;
    observacao: string | null = null;
    dataInicioVigencia = "";
    dataFimVigencia: string | null = null;
    ativo = true;
    produto: Produto | null = null;
    ufDestino: string | null = null;
    codigoProdutoCliente: string | null = null;
    descricaoProdutoNota: string | null = null;
    unidadeComercial: string | null = null;
    ean: string | null = null;
    cfop: string | null = null;
    cstIcms: string | null = null;
    csosn: string | null = null;
    cstIpi: string | null = null;
    codigoEnquadramentoIpi: string | null = null;
    cstPis: string | null = null;
    cstCofins: string | null = null;
    beneficioFiscal: string | null = null;
    aliquotaIcms: number | null = null;
    aliquotaIcmsUfDestino: number | null = null;
    aliquotaFcpUfDestino: number | null = null;
}
